export default "__VITE_PUBLIC_ASSET__925246b1__"